import { render, staticRenderFns } from "./DeRichTextView.vue?vue&type=template&id=5e8c9a5b&scoped=true&"
import script from "./DeRichTextView.vue?vue&type=script&lang=js&"
export * from "./DeRichTextView.vue?vue&type=script&lang=js&"
import style0 from "./DeRichTextView.vue?vue&type=style&index=0&id=5e8c9a5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c9a5b",
  null
  
)

export default component.exports